import React, { useRef } from 'react'
import styled from '@emotion/styled'

import { useSelector, useDispatch } from 'react-redux'
import * as Selectors from 'state/selectors'
import * as Actions from 'state/actions'

import Activity from './Activity'
import RunningActivity from './RunningActivity'
import Scrollable from 'components/shared/Scrollable'

import _ from 'lodash'
import { some, find } from 'shared/utils/array'
import BusyTyping from './widgets/BusyTyping'

const ReloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  margin-top: 25px;
  align-items: center;
  margin-right: 15px;
  
  user-select: none;
  cursor: pointer;
`

const ReloadButton = styled.div`
  margin-bottom: 10px; 
  background-color: #6DB5BE;
  color: #ffffff;
  height: min-content;
  padding: 5px 16px;
  border-radius: 4px;
  
  user-select: none;
  cursor: pointer;
  transition: opacity .3s ease;

`

const isOriginatorChanged = ({ lastOriginator, originator }) => {
  return (lastOriginator?.actorId !== originator?.actorId)
    && (originator?.role === 'external' || lastOriginator?.role === 'external')
}

const ReloadPageContainer = () => {
  return (
    <>
    <ReloadWrapper >
      <ReloadButton
        onClick={ () => window.location.reload()}
      >
        Refresh
      </ReloadButton>
        Connection was lost. Please, refresh page.
    </ReloadWrapper>
      </>
  )
}

const renderActivities = (activities) => {
  let lastOriginator
  let noAvatar
  return activities?.map((activity, idx) => {
    const component = !activity?.failed && !activity?.tempId ? (
      <Activity
        key={idx}
        activity={activity}
        avatar={
          (!noAvatar && activity?.originator && lastOriginator?.actorId !== activity.originator?.actorId)
            ? activity?.originator
            : null
        }
        isLeft={activity?.originator?.role === 'external'}
        endOfBlock={activity.originator && isOriginatorChanged({ lastOriginator, originator: activity.originator })}
      />
    ) : (
      <RunningActivity
        key={idx}
        payload={activity}
        avatar={lastOriginator?.role === 'external' ?  activity?.originator : null}
        isLeft={activity?.originator?.role === 'external'}
        endOfBlock={activity?.originator && isOriginatorChanged({ lastOriginator, originator: activity?.originator })}
      />
    )


    if(activity.originator) {
      lastOriginator = activity.originator
    }

    if(activity.failed || activity.tempId){
      noAvatar = true
    }

    return component
  }
)
}

const ChatHistory = () => {
  const test = useRef(null)

  const dispatch = useDispatch()
  const activities = useSelector(Selectors.getActivities)
  const isLoading = useSelector(Selectors.areActivitiesLoading)
  const page = useSelector(Selectors.getActivitiesPage)
  const nextPage = useSelector(Selectors.getActivitiesNextPage)
  const isSocketConnectionLost = useSelector(Selectors.isSocketReconnectionError)
  const scrollToBottomRequired = useSelector(Selectors.getActivitiesScrollToBottomRequired)
  const scrollToTopRequired = useSelector(Selectors.getActivitiesScrollToTopRequired)
  const busyTypingCollection = useSelector(Selectors.getBusyTypingCollection)
  const selectedInteraction = useSelector(Selectors.getSelectedInteraction)
  
  const isNewInteractionLoading = isLoading && page === 0

  let originator = null
  let botOriginator = null

  for(let i = 0; i < busyTypingCollection.length; i++){
    const isBusyTyping = some( selectedInteraction.threads,  thread => thread?.threadId === busyTypingCollection[i]?.threadId && busyTypingCollection[i].originator.role !== 'bot')
    const isBotOriginator = find( selectedInteraction.threads,  thread => thread?.threadId === busyTypingCollection[i]?.threadId && busyTypingCollection[i].originator.role === 'bot')
    if(isBusyTyping) {
      originator = busyTypingCollection[i].originator
    }
    if(isBotOriginator) {
      botOriginator = busyTypingCollection[i].originator
    }
  }

  const handleLoad = () => {
    if(!isLoading && nextPage > 0) {
      dispatch(Actions.fetchActivities())
    }
  }

  const scrollToBottomCallback = () => dispatch(Actions.activitiesBottomReached())
  const scrollToTopCallback = () => dispatch(Actions.finishScrollToTop())

  return (
    !isNewInteractionLoading && (
      <Scrollable
        ref={test}
        isReverse
        blockMargin
        handleLoad={_.debounce(handleLoad, 500)}
        scrollToBottomRequired={scrollToBottomRequired}
        scrollToTopRequired={scrollToTopRequired}
        scrollToBottomCallback={scrollToBottomCallback}
        scrollToTopCallback={scrollToTopCallback}
      >
        { activities && renderActivities(activities) }
        { originator && <BusyTyping avatar = {originator}/> }
        { botOriginator && <BusyTyping avatar = {botOriginator}/> }
        { isSocketConnectionLost && <ReloadPageContainer /> }
      </Scrollable>
 
    )
  )
}

export default  ChatHistory
